import PhotoSwipe from 'components/photoswipe';
import PhotoSwipeLightbox from 'components/photoswipe-lightbox';

const lightbox = new PhotoSwipeLightbox({
  gallery: '[id^="Product-gallery-"]',
  children: 'a[itemprop="contentUrl"]',
  wheelToZoom: true,
  pswpModule: () => import('components/photoswipe'),
  allowPanToNext: false,
});
lightbox.on('uiRegister', function () {
  lightbox.pswp.ui.registerElement({
    name: 'custom-caption',
    order: 9, 
    isButton: false,
    appendTo: 'root',
    html: '',
    onInit: (el, pswp) => {
      pswp.on('change', () => {
        const currSlide = pswp.currSlide.data.element;
        const captionText =
          currSlide.dataset.caption ||
          currSlide.querySelector('img')?.alt ||
          '';
        el.innerHTML = captionText;
        el.className = 'pswps__custom-caption';
      });
    },
  });
});

// lightbox.on('uiRegister', () => {
//   lightbox.pswp.on('change', () => {
//     const pswp = lightbox.pswp;
//     const currSlide = pswp.currSlide.data.element;
//     const captionText =
//       currSlide.dataset.caption ||
//       currSlide.querySelector('img')?.alt ||
//       '';

//     // বর্তমান zoom-wrap element ধরো
//     const zoomWrap = pswp.currSlide?.holderElement?.querySelector('.pswp__zoom-wrap');

//     if (zoomWrap) {
//       // আগের caption remove করো (যদি থাকে)
//       const oldCaption = zoomWrap.querySelector('.pswps__custom-caption');
//       if (oldCaption) oldCaption.remove();

//       // নতুন caption বানাও
//       const captionEl = document.createElement('div');
//       captionEl.className = 'pswps__custom-caption';
//       captionEl.innerHTML = captionText;

//       // zoom-wrap এর ভেতরে append করো
//       zoomWrap.appendChild(captionEl);
//     }
//   });
// });

lightbox.init();
